<template>
  <div class="select-multi bg-transparent inline-block pos-rel minw10 w100p" v-click-outside.self="closeMenu"
    :class="{ 'disabled-select': disabled }">
      <div class="select">
        <div @click.self="toggleMenu" class="h3 lh1-2 w100p display-flex align-center justify-center overflow-hidden ph1">
        {{ placeholder || label }}
        <bh-icon icon="play-down" class="pr1-2 ml1 hide-mb f-5 text-violet inline" @output.self="toggleMenu" />
        </div>
        <ul class="dropdown-menu w100p maxh40 overflow-x-hidden scroll pos-abs top0 left0 bg-white pa0 ma0"
          v-if="showMenu">
          <li class="display-flex align-center justify-center overflow-hidden w100p pointer text-left ph1" @click.self="toggleMenu">
            {{ placeholder || label }}
          </li>
          <li v-if="showSelectAll" id="All" class="display-flex align-center justify-around h3 overflow-hidden w100p border-bottom pointer text-left pv2 pl1">
              <bh-icon :icon="`${ allSelected ? 'check-mark': 'radio-unchecked' }`" @output="onSelectAll" />
              <span class="inline-block minw7 text-black" @click.self="onSelectAll">All</span>
          </li>
          <li class="display-flex align-center justify-around h3 overflow-hidden w100p border-bottom pointer text-left pv2 pl1" v-for="option in optionsPrivate" :key="`key-${option.value}`"
            :id="`key-${option.value}`"
            :class="{ 'selected' : option.selected }">
            <bh-icon :icon="`${ option.selected ? 'check-mark': 'radio-unchecked' }`" @output="onSelect(option)" />
            <span class="inline-block minw7 text-black" @click.self="onSelect(option)">{{ option.label }}</span>
          </li>
          <li class="display-flex align-center justify-center overflow-hidden w100p pointer pa1 bg-violet text-white" @click.self="emitValue()" v-if="emitActionButton">
            {{ actionButtonLabel }}
          </li>
        </ul>
      </div>
      <!-- the actual select element is hidden -->
      <label class="hidden-element">
        <select class="bg-white pointer pos-rel none"></select>
      </label>
  </div>
</template>

<script>

export default {
  name: 'bh-multi-select',
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return [
          { label: 'Options 1', value: '1', selected: false },
          { label: 'Options 2', value: '2', selected: false }
        ]
      }
    },
    showSelectAll: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    emitActionButton: {
      type: Boolean,
      default: false
    },
    actionButtonLabel: {
      type: String,
      default: 'Add'
    }
  },
  mounted() {
    this.optionsPrivate = JSON.parse(JSON.stringify(this.options))
    this.allSelected = this.optionsPrivate.every(opt => opt.selected === true)
  },
  watch: {
    options: {
      handler() {
        this.optionsPrivate = JSON.parse(JSON.stringify(this.options))
        this.allSelected = this.optionsPrivate.every(opt => opt.selected === true)
      }
    }
  },
  data() {
    return {
      showMenu: false,
      optionsPrivate: [],
      allSelected: false,
      filterClicked: false
    }
  },
  methods: {
    optionId(value) {
      return value ? `option-${value.toString()}` : ''
    },
    closeMenu() {
      this.showMenu = false
      if (!this.filterClicked) {
        this.allSelected = true
        for (const option of this.optionsPrivate) { option.selected = true }
      }
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    onSelect(option) {
      option.selected = !option.selected
      this.allSelected = this.optionsPrivate.every(opt => opt.selected === true)
      if (!this.emitActionButton) {
        this.emitValue()
      }
    },
    onSelectAll() {
      this.allSelected = !this.allSelected
      for (const option of this.optionsPrivate) { option.selected = this.allSelected }
    },
    emitValue() {
      this.filterClicked = !this.allSelected
      this.$emit('output', this.optionsPrivate.filter(option => option.selected))
      this.closeMenu()
    }
  }
}
</script>

<style scoped>
  .select-multi.disabled-select {
    opacity: 0.5;
  }

  .select {
    transition: all 0.4s ease;
  }

  ul, li {
    list-style: none;
  }

  .select-multi.disabled-select .select {
    pointer-events: none;
  }

  ul.dropdown-menu {
    z-index: 1000;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  }

  ul.dropdown-menu li {
    user-select: none;
  }
</style>
